import { atom } from "recoil";

import { IClip } from "MVVM/@types";
import {
  PlaylistClips,
  PlaylistClip,
  TopViewedPlayersList,
  TopViewedMatchesList,
  TopViewedTeamsList,
  TopViewedPlayersByCountryList,
} from "MVVM/Views/EmbeddablePlaylist/@types";

export type IClipWithMetadata = IClip & {
  metadata: { key: string; value: string }[];
};

export const PlaylistClipsState = atom<PlaylistClips | null>({
  key: "PlaylistClipsState",
  default: null,
});

export const ActivePlaylistClipState = atom<IClipWithMetadata | null>({
  key: "ActivePlaylistClipState",
  default: null,
});

export const PlayerPhotoState = atom<string>({
  key: "PlayerPhotoState",
  default: "",
});

export const TeamLogoState = atom<string>({
  key: "TeamLogoState",
  default: "",
});

export const PlayerNameState = atom<string>({
  key: "PlayerNameState",
  default: "",
});

export const FallbackPlaylistTypeState = atom<string>({
  key: "FallbackPlaylistTypeState",
  default: "",
});

export const NextUpPlaylistState = atom<boolean>({
  key: "NextUpPlaylistState",
  default: false,
});

export const MatchTypeState = atom<string>({
  key: "MatchTypeState",
  default: "",
});

export const DisplayEmptyState = atom<boolean>({
  key: "DisplayEmptyState",
  default: false,
});

export const FallbackPlaylistState = atom<boolean>({
  key: "FallbackPlaylistState",
  default: false,
});

export const WatchedClipsCountState = atom<number>({
  key: "WatchedClipsCountState",
  default: 1,
});

export const ShowWatchLimitBlockerState = atom<boolean>({
  key: "ShowWatchLimitBlockerState",
  default: false,
});

export const BlockedPlayerNameState = atom<string>({
  key: "BlockedPlayerNameState",
  default: "",
});

export const BlockedClipState = atom<PlaylistClip | null>({
  key: "BlockedClipState",
  default: null,
});

export const PlaylistIdState = atom<string>({
  key: "PlaylistIdState",
  default: "",
});

export const TopViewedPlayersState = atom<TopViewedPlayersList | null>({
  key: "TopViewedPlayersState",
  default: null,
});

export const TopViewedPlayersByCountryState =
  atom<TopViewedPlayersByCountryList | null>({
    key: "TopViewedPlayersByCountryState",
    default: null,
  });

export const TopViewedMatchesState = atom<TopViewedMatchesList | null>({
  key: "TopViewedMatchesState",
  default: null,
});

export const TopViewedTeamsState = atom<TopViewedTeamsList | null>({
  key: "TopViewedTeamsState",
  default: null,
});

export const RenderPreMatchState = atom<boolean>({
  key: "RenderPreMatchState",
  default: false,
});
